import React, { Component } from 'react';
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import { Grid, Typography, Divider, Paper } from '@material-ui/core';

import FacetChip from '../../components/Article/common/FacetChip';
import FacetAutosuggest from '../../components/Article/common/FacetAutosuggest';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PersonIcon from '@material-ui/icons/Person';
import BusinessIcon from '@material-ui/icons/Business';
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import TransferWithinAStationIcon from '@material-ui/icons/TransferWithinAStation';
import PlaceIcon from '@material-ui/icons/Place';
import RouterIcon from '@material-ui/icons/Router';
import GroupIcon from '@material-ui/icons/Group';
import NotesIcon from '@material-ui/icons/Notes';
import FlagIcon from '@material-ui/icons/Flag';

import TagsInput from 'react-tagsinput'

import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";

// styles
import imagesStyles from "assets/jss/material-kit-pro-react/imagesStyles.jsx";
import cardStyles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx";
import MediaQuery from 'react-responsive';

const fieldsIntValues = ["staff_changes", "grants", "rfps", "advisories"];

const lookup = {
    'geos': 'Geography',
    'people': 'People',
    'organizations': 'Organizations',
    'subjects': 'Subjects',
    'pop_groups': 'Population Groups',
    'sources': 'Sources',
    'advisories': 'Advisories',
    'grants': 'Grant',
    'rfps':'RFP',
    'staff_changes': 'Staff Changes',
    'data_sources': 'Data Sources'
}

const styles = theme => ({
    ...imagesStyles,
    ...cardStyles,
    sideBar: {

        float: 'left',
        overflowY: 'auto',
        position: 'fixed',
        width: "20%",
        bottom: '0',
        height: 'calc(100vh - 155px)',
        zIndex: '11',
        background: '#ffffff',

        "@media screen and (max-width: 1200px)": {
            maxWidth: "100%",
            width: "100%",
            height: "calc(100vh - 90px)"
        },

        "@media screen and (max-width: 600px)": {
            height: "calc(100vh - 56px)",
        }
    },
    sidebarBucketsContainer: {
        padding: theme.spacing.unit / 2,
        justifyContent: 'center',
        borderRadius: 0
    },
    sidebarBuckets: {
        padding: theme.spacing.unit / 2,
        justifyContent: 'center',
        background: "#FFF",
        borderRadius: 0
    },
    sidebarBucketsDetails: {
        //flexWrap: 'wrap',
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-around',
        width: '90%',
        background: '#ffffff'
    },
    tagInput: {color: "#ffffff"},
    icon: {
        marginRight: '5px'
    },

    media: {
        "@media screen and (max-width: 600px)": {
            margin: '0',
            fontSize: '0.9rem',
        }
    },

    panel: {
        "@media screen and (max-width: 600px)": {
            minHeight: '25px',

            '& :first-child': {
                margin: '0'
            }
        }
    }
})

class SideBar extends Component {

    formatNumber(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    formatName(name, facet, count) {
        if (facet === 'rfps')
            return name === 0 || name === "0" ? `Non-RFP||${count}||0` : `RFP||${count}||1`;
        if (facet === 'grants')
            return name === 0 || name === "0" ? `Non-grant||${count}||0` : `Grant||${count}||1`;
        if (facet === 'staff_changes')
            return name === 0 || name === "0" ? `None||${count}||0` : `Changes||${count}||1`;
        if (facet === 'advisories')
            return name === 0 || name === "0" ? `Non-advisory||${count}||0` : `Advisories||${count}||1`;
        return name;
    }

    tagRender(onClick, facet, uiState, onRemove, allValues, classes, onlySelected = false) {
        const isBoolField = fieldsIntValues.indexOf(facet) > -1;
        return (p) => {
            let { tag, getTagDisplayValue } = p,
                tagSplit = tag.split('||'),
                correctedTag = isBoolField && tagSplit.length === 3 ? this.formatName(tagSplit[0], facet, tagSplit[1]) : tag,
                split = getTagDisplayValue(correctedTag).split('||'),
                key = split[0],
                delimitedValue = split.length > 2 ? isBoolField ? parseInt(split[2]) : split[2] : '',
                isSelected = uiState && uiState.facets && uiState.facets[facet] && (uiState.facets[facet].indexOf(key) > -1 || (split.length > 2 && uiState.facets[facet].indexOf(delimitedValue) > -1)),
                currentObj = allValues.filter(f => (f.name + "").substring(0, key.length) === key);

            if (onlySelected) {
                if (isSelected) {
                    const google_info = currentObj.length && currentObj[0].google_info ? currentObj[0].google_info : null;
                    return <FacetChip key={key} props={{ classes, google_info, onClick, onRemove, isSelected, facet, ...p, tag:correctedTag }} />;
                }
                return null;
            }

            const google_info = currentObj.length && currentObj[0].google_info ? currentObj[0].google_info : null;
            return <FacetChip key={key} props={{ classes, google_info, onClick, onRemove, isSelected, facet, ...p }} />
        }
    }

    renderItem(key, index) {
        const { classes } = this.props,
            { fetchArticles, fetchFacetDetail } = this.props.data,
            { facets } = this.props.state,
            results = fetchArticles.records,
            handleFacetClick = this.props.handleFacetClick;
        let suggestions = fetchFacetDetail;

        function autoCompleteInput(facet, handleFacetAutoComplete, uiState, allValues) {
            return ({ addTag, ...props }) => {
                const handleOnChange = (e, { newValue, method }) => {
                    if (method === 'enter') {
                        e.preventDefault();
                    }
                    else {
                        if (props.onChange) {
                            props.onChange(e);
                        }
                        handleFacetAutoComplete(e, facet);
                    }
                };
                const attr = {
                    facet,
                    uiState,
                    suggestions,
                    handleFacetClick,
                    addTag,
                    handleOnChange,
                    otherProps: props
                }

                return fieldsIntValues.indexOf(facet) > -1 ? null : <FacetAutosuggest props={{ ...attr }} />
            }
        }

        if (!lookup[key]) {
            return null;
        }

        let currentIcon = <PersonIcon iconcolor="info" className={classes.icon}/>;
        if (key === "geos")
            currentIcon = <PlaceIcon iconcolor="info" className={classes.icon}/>
        else if (key === "organizations")
            currentIcon = <BusinessIcon iconcolor="info" className={classes.icon}/>
        else if (key === "subjects")
            currentIcon = <NotesIcon iconcolor="info" className={classes.icon}/>
        else if (key === "pop_groups")
            currentIcon = <GroupIcon iconxolor="info" className={classes.icon} />
        else if (key === "sources")
            currentIcon = <RouterIcon iconxolor="info" className={classes.icon}/>
        else if (key === "data_sources")
            currentIcon = <CollectionsBookmarkIcon iconxolor="info" className={classes.icon}/>
        else if (key === "rfps")
            currentIcon = <NotificationImportantIcon iconxolor="info" className={classes.icon}/>
        else if (key === "grants")
            currentIcon = <NotificationImportantIcon iconxolor="info" className={classes.icon}/>
        else if (key === "staff_changes")
            currentIcon = <TransferWithinAStationIcon iconxolor="info" className={classes.icon}/>
        else if (key === "advisories")
            currentIcon = <FlagIcon iconxolor="info" className={classes.icon}/>

        return (
            <Paper elevation={0} key={index} className={classes.sidebarBucketsContainer}>
                <ExpansionPanel className={classes.sidebarBuckets}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} style={{fill: '#000000'}}className={classes.panel}>
                        <div className={classes.column}>
                            <Typography variant="title" gutterBottom style={{ color: "#000000" }} className={classes.media}>
                                <MediaQuery minWidth={600}>
                                    {currentIcon}
                                </MediaQuery> 
                                {lookup[key]}
                            </Typography>
                            {
                                this.props.state.facets && this.props.state.facets[key] && this.props.state.facets[key].length > 0 ?
                                    <Typography className={classes.secondaryExpansionHeading}>
                                        {/* {this.props.state.facets[key].length} selected */}
                                        {
                                            <TagsInput 
                                                allowDeleteFromEmptyInput={false}
                                                value={
                                                    results.facet_counts[key]
                                                        .filter(d => this.props.state.facets[key].indexOf(d.name) > -1 || this.props.state.facets[key].indexOf(d.code) > -1)
                                                        .map(d => `${d.name}||${this.formatNumber(d.count)}||${d.code ? d.code.toUpperCase() : d.code}`)
                                                }
                                                onChange={d => d}
                                                onRemove={this.props.handleFacetClick}
                                                tagProps={{ className: "react-tagsinput-tag info" }}
                                                renderTag={
                                                    this.tagRender(
                                                        this.props.handleFacetClick,
                                                        key,
                                                        this.props.state,
                                                        this.props.handleFacetRemove,
                                                        results.facet_counts[key],
                                                        classes,
                                                        true
                                                    )
                                                }
                                                renderInput={() => null}
                                            />
                                        }
                                    </Typography>
                                    : null
                            }
                        </div>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.sidebarBucketsDetails}>
                        {
                            this.props.data.fetchArticles.isFetching ?
                                <CustomLinearProgress color="primary" />
                                : <TagsInput 
                                    allowDeleteFromEmptyInput={false}
                                    value={
                                        results.facet_counts[key]
                                            .filter(d => this.props.state.facets[key].indexOf(d.name) === -1 && this.props.state.facets[key].indexOf(d.code) === -1)
                                            .map(d => fieldsIntValues.indexOf(key) > -1 ? this.formatName(d.name, key, d.count) : `${this.formatName(d.name, key, d.count)}||${this.formatNumber(d.count)}||${d.code ? d.code.toUpperCase() : d.code}`)
                                            .slice(0, 10)
                                    }
                                    onChange={d => d}
                                    renderInput={autoCompleteInput(key, this.props.handleFacetAutoComplete, this.props.state, results.facet_counts[key])}
                                    onRemove={this.props.handleFacetClick}
                                    tagProps={{ className: "react-tagsinput-tag info" }}
                                    renderTag={
                                        this.tagRender(
                                            this.props.handleFacetClick,
                                            key,
                                            this.props.state,
                                            this.props.handleFacetRemove,
                                            results.facet_counts[key],
                                            classes
                                        )
                                    }
                                    maxTags={10}
                                    inputProps={{
                                        placeholder: `Search ${
                                            lookup[key].toLowerCase() === "pop_groups" ?
                                                "population groups"
                                                : lookup[key].toLowerCase()
                                        }`,
                                        className: "react-tagsinput-input " + classes.tagInput
                                    }}
                                />
                        }
                    </ExpansionPanelDetails>
                    <Divider />
                </ExpansionPanel>
            </Paper>
        )
    }

    render() {
        const { classes, brandComponent } = this.props;
        const { fetchArticles } = this.props.data,
            results = fetchArticles.records;

        return (
            <Grid item xs={12} md={3} className={classes.sideBar} id="facets-sidebar">
                <MediaQuery maxWidth={600}>
                    {brandComponent}
                </MediaQuery>
                {
                    !results || !results.facet_counts
                        ? null
                        : Object.keys(results.facet_counts).map((key, index) => this.renderItem(key, index))
                }
            </Grid>
        )
    }

}

SideBar.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object,
    fetchArticles: PropTypes.object,
    handleFacetAutoComplete: PropTypes.func,
    handleFacetClick: PropTypes.func,
    handleFacetRemove: PropTypes.func,
    state: PropTypes.object,
    brandComponent: PropTypes.element
}

export default withStyles(styles)(SideBar);


// WEBPACK FOOTER //
// ./src/components/Article/SideBar.jsx